import { render } from "./BusinessCardCollectionItem.vue?vue&type=template&id=47ba7944&scoped=true"
import script from "./BusinessCardCollectionItem.vue?vue&type=script&lang=js"
export * from "./BusinessCardCollectionItem.vue?vue&type=script&lang=js"

import "./BusinessCardCollectionItem.vue?vue&type=style&index=0&id=47ba7944&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ba7944"]])

export default __exports__